export default class ArchivedTracker {

  constructor () {
    throw Error('No instances!');
  }

  static archived = [];

  static add (archivedItemId) {
    this.archived.push(archivedItemId);
  }

  static find (archivedItemId) {
    return !!this.archived.indexOf(archivedItemId);
  }

}